// extracted by mini-css-extract-plugin
export var border = "_f-8";
export var brand = "_f-t";
export var button = "_f-l";
export var center = "_f-a";
export var centered = "_f-6";
export var closeButton = "_f-c";
export var disabledWrapper = "_f-m";
export var error = "_f-p";
export var extraLarge = "_f-4";
export var extraSmall = "_f-1";
export var fill = "_f-i";
export var footer = "_f-h";
export var footerAction = "_f-j";
export var footerButtons = "_f-k";
export var header = "_f-7";
export var headerWithClose = "_f-d";
export var icon = "_f-o";
export var info = "_f-s";
export var inline = "_f-9";
export var large = "_f-3";
export var main = "_f-e";
export var modal = "_f-0";
export var nearFull = "_f-5";
export var neutral = "_f-u";
export var noPadding = "_f-g";
export var none = "_f-v";
export var scrollable = "_f-f";
export var small = "_f-2";
export var success = "_f-r";
export var tight = "_f-n";
export var titleIcon = "_f-b";
export var warn = "_f-q";